import t from "./types";
import { Api } from '../../services/httpService';
import { dispatch } from "react-hot-toast";




export const getFilterData = (param, filterFor, pageNo, size) => async (dispatch) => {
    let pageSize = {
        "size": size ? size : 20,
        "page": pageNo ? pageNo : 0
    }

    for (let prop in param) if (!param[prop]) delete param[prop];

    let returnedTarget = Object.assign(param, pageSize);

    var res = await Api('post', `/${filterFor}/findAsParam`, returnedTarget);
    if (res.success) {
        await dispatch({ type: t.GET_FILTER_DATA, payload: res.body, filterFor: filterFor, currentPage: pageSize?.page ?? 0 })
    } else {
        console.log("Pagination error", res);
         dispatch({ type: t.GET_FILTER_DATA, payload: false, filterFor: filterFor, });
    }
}


export const getUnpaidInvoices = (merchantId, buyerPlatformId, pageNo) => async (dispatch) => {

    let page = pageNo ? pageNo : 0;
    try {
        const res = await Api('get', `/invoices/unpaid/${merchantId}/${buyerPlatformId}?page=${page}&size=20`);
        if (res) {
            await dispatch({ type: t.UN_PAID_INVOICES_LIST, payload: res });
        }
    } catch (error) {
        console.log("Error", error);
    }
}
export const setNotificationData = (data=null) => async (dispatch) => {
    dispatch({ 
        type: t.NOTIFICATION_REDIRECT, 
        payload: data ?? {
            type:"",
            buyerPlatformId:"",
            buyerPlatformType:"",
            objectId:"",
            onjectData:{}
        }
    });
}

